module.exports = __webpack_public_path__ + "img/Kovacs-Szecsi_Attila_-General Director.4de99094.jpg";